 
import CreateHttpService from "../../helpers/HttpService";
 
 

 // Create Test
const createTest = async (data:any) => {  
       const HttpService = CreateHttpService(); 
  const { data:datas } = await HttpService.post( `/api/v1/test`,data)  
  return datas
}
 
 // Get All Created Test
const allCreatedTest = async ( ) => {  
     const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get( `/api/v1/test`)  
  return data
}
 
 // Created Test Details
const createdTestDetails = async (id:any ) => {   
   const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get( `/api/v1/test/${id}`)  
  return data
}
 
 // Send Test 
const sendTest = async (info: any) => {  
  const { data: { id }, testTotleScore: score } = info;   
  const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.put( `/api/v1/test/mark-completed-test/${id}`,{score:score})  
  return data
}
 
 // Evaluation Update 
const evaluationUpdate = async (info: any) => {   
  
  const {   id  ,comment ,status } = info; 
   const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.put( `/api/v1/application/evaluating/${id}`,{comment,status})  
  return data
}
 
 // Eligibility Check 
const eligibilityCheck = async (inputs: any) => {   
   
  
    const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/check-test-eligibility`,inputs)  
 
  return data
}

 // Send Email
const sendEmail = async (inputs: any) => {   
 
  
     const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/email/send-email`,inputs)  
 
  return data
}
 // Hire Applicant
const hireApplicant = async (inputs: any) => {   
   
    const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.put( `/api/v1/email/send-email`,inputs)  
 
  return data
}
 

const testSlice = { 
  createTest, 
  allCreatedTest,
  createdTestDetails,
  sendTest,
  evaluationUpdate,
  eligibilityCheck,
  sendEmail,
  hireApplicant
}

export default testSlice